import { Table } from "antd";
import React from "react";

const ConsolidatedReportsTable = ({
        columns,
        dataSource = [],
        expandable = {},
    scroll,
    summary,
    loading = false,
    ...rest
}) => {
        ConsolidatedReportsTable.Summary = Table.Summary;
    return (
        <div style={{ position: "relative", overflowX: "auto" }}>
            <Table
                columns={columns}
                dataSource={dataSource}
                expandable={expandable}
                pagination={false}
                bordered
                loading={loading}
                scroll={scroll}      // ✅ forwarded
                summary={summary}    // ✅ forwarded
                className="custom-ant-table"
                {...rest}      
               rowClassName={(record, index) => {
            
                                               if (record?.isHeading == '1') {
                                                        return 'table-row-heading';
                                                } else if (record?.isHeading == '2') {
                                                        return 'table-row-light-blue';
                                                }
                                                return '';
                                        }}
            />
        </div>
    );
};

/* 🔑 REQUIRED FOR STICKY TOTAL */

export default ConsolidatedReportsTable;
